export const articles = [
  {
    id: 1,
    title: "快猫短视频2026年度创作者大会圆满落幕",
    slug: "2026-creator-conference",
    excerpt: "2026年快猫短视频年度创作者大会在杭州国际博览中心盛大举行，来自全国各地的2000多位创作者齐聚一堂，共同见证快猫创作者生态的蓬勃发展。",
    cover: "https://readdy.ai/api/search-image?query=A%20large%20modern%20conference%20hall%20filled%20with%20people%20attending%20a%20tech%20event%20with%20colorful%20stage%20lights%20and%20large%20screens%2C%20professional%20event%20photography%2C%20energetic%20atmosphere&width=1200&height=675&seq=article-conference-01&orientation=landscape",
    category: "平台动态",
    author: "快猫官方",
    date: "2026-06-15",
    readTime: "8分钟",
    views: "12.5万",
    tags: ["创作者大会", "平台动态", "创作者生态"],
    content: `
      <p>2026年6月12日至14日，以「创造无限可能」为主题的快猫短视频年度创作者大会在杭州国际博览中心盛大举行。这是快猫短视频成立以来规模最大的一次创作者盛会，吸引了来自全国各地的2000多位优质创作者、行业专家和媒体代表参与。</p>
      
      <h2>大会亮点回顾</h2>
      
      <p>在为期三天的大会中，快猫短视频发布了多项重磅产品和政策，包括全新升级的创作者工具套件、更加完善的流量分配机制，以及总额高达50亿元的创作者扶持基金计划。</p>
      
      <p>快猫短视频CEO在开幕致辞中表示：「创作者是快猫最宝贵的财富。未来三年，我们将持续加大对创作者的支持力度，让每一位有才华的创作者都能在快猫平台上实现自己的价值。」</p>
      
      <h2>创作者扶持计划升级</h2>
      
      <p>本次大会最受关注的莫过于全新发布的「星光计划3.0」。该计划从流量扶持、商业变现、内容工具三个维度全面升级：</p>
      
      <ul>
        <li><strong>流量扶持：</strong>新创作者将获得专属冷启动流量池，优质内容将获得多轮推流机会，确保好内容不被埋没。</li>
        <li><strong>商业变现：</strong>新增品牌任务市场、直播带货分成优化、知识付费专栏等多元变现通道。</li>
        <li><strong>内容工具：</strong>推出AI辅助创作工具「快影」，支持智能剪辑、自动字幕、一键成片等功能。</li>
      </ul>
      
      <h2>年度创作者颁奖</h2>
      
      <p>大会现场还颁发了「年度最佳创作者」「年度最佳新人」「年度最具影响力内容」等多个重磅奖项。获奖创作者分享了他们的创作心得和成长故事，现场掌声不断。</p>
      
      <p>获得「年度最佳创作者」的@旅行者小张在获奖感言中说：「感谢快猫平台给了我展示自己的舞台，也感谢每一位支持我的粉丝。我会继续用心创作，带大家看更美的世界。」</p>
      
      <h2>展望未来</h2>
      
      <p>快猫短视频作为国内领先的短视频平台，将持续深耕内容生态建设，为创作者和用户创造更大价值。未来，快猫将继续围绕「技术创新」和「内容品质」两大核心，打造更加繁荣健康的短视频生态。</p>
    `,
  },
  {
    id: 2,
    title: "快猫会员权益全面升级：更多专属特权等你来享",
    slug: "vip-upgrade-2026",
    excerpt: "快猫会员体系迎来重大升级，新增4K超清画质、无广告体验、专属客服等多项权益，提升用户观看体验。",
    cover: "https://readdy.ai/api/search-image?query=A%20luxurious%20golden%20membership%20card%20on%20a%20dark%20elegant%20background%20with%20soft%20sparkling%20lights%2C%20premium%20lifestyle%20photography%2C%20exclusive%20atmosphere&width=1200&height=675&seq=article-vip-02&orientation=landscape",
    category: "产品更新",
    author: "快猫产品团队",
    date: "2026-05-20",
    readTime: "5分钟",
    views: "8.9万",
    tags: ["会员权益", "产品更新", "VIP"],
    content: `
      <p>亲爱的快猫用户，我们很高兴地宣布：快猫会员权益迎来全面升级！为了给会员用户带来更优质的观看体验，我们对会员权益进行了精心优化和丰富。</p>
      
      <h2>全新会员权益一览</h2>
      
      <h3>1. 4K超清画质</h3>
      <p>会员用户现在可以享受4K超高清画质播放，配合快猫自研的视频增强技术，让每一帧画面都纤毫毕现。无论是美食特写还是风景大片，都能获得影院级的视觉享受。</p>
      
      <h3>2. 纯净无广告</h3>
      <p>会员用户在观看视频时将不再看到任何形式的广告打扰，从打开App到沉浸式观看，全程丝滑流畅，让创作者的内容成为唯一的焦点。</p>
      
      <h3>3. 专属会员标识</h3>
      <p>升级后的会员标识更加醒目精致，在评论区、直播间等多处展示，彰显你的尊贵身份。同时支持自定义会员铭牌颜色。</p>
      
      <h3>4. 优先客服通道</h3>
      <p>会员用户享受专属客服通道，问题响应时间缩短至5分钟内，重要问题由资深客服专员一对一跟进处理。</p>
      
      <h3>5. 每月会员福利</h3>
      <p>每月推出会员专属福利活动，包括热门商品折扣券、品牌联名礼品、线下活动优先参与权等超值权益。</p>
      
      <h2>会员方案与价格</h2>
      <p>为满足不同用户的需求，我们提供灵活的会员方案：月度会员25元、季度会员68元（省7元）、年度会员238元（省62元）。首月开通更享1元体验价！</p>
      
      <p>立即打开快猫App，进入「我的」-「会员中心」即可查看完整权益并开通会员。</p>
    `,
  },
  {
    id: 3,
    title: "快猫短视频安全审核机制全解析：守护每一份创作",
    slug: "safety-review-system",
    excerpt: "深入了解快猫短视频的内容安全审核体系，从AI智能识别到人工复审，全方位保障平台内容安全健康。",
    cover: "https://readdy.ai/api/search-image?query=A%20modern%20digital%20security%20concept%20showing%20a%20shield%20with%20circuit%20patterns%20on%20a%20clean%20tech%20background%2C%20cybersecurity%20visualization%2C%20professional%20and%20trustworthy%20design&width=1200&height=675&seq=article-safety-03&orientation=landscape",
    category: "平台动态",
    author: "快猫安全团队",
    date: "2026-04-10",
    readTime: "7分钟",
    views: "6.7万",
    tags: ["安全审核", "内容安全", "AI审核"],
    content: `
      <p>作为一家负责任的内容平台，快猫短视频始终将内容安全放在首位。我们建立了多层次、全流程的内容安全审核体系，确保每一位用户都能在安全、健康的环境中创作和观看内容。</p>
      
      <h2>三层审核机制</h2>
      
      <h3>第一层：AI智能预审</h3>
      <p>所有上传的视频内容首先经过AI智能审核系统的实时检测。我们的AI模型经过海量数据训练，能够精准识别违规内容，包括但不限于：色情低俗、暴力血腥、违法违规、虚假信息等。AI预审的平均响应时间仅为0.3秒，确保高效筛选。</p>
      
      <h3>第二层：人工复审</h3>
      <p>对于AI系统判定为疑似违规或边界模糊的内容，将自动进入人工复审环节。快猫拥有超过500人的专业审核团队，7×24小时轮班值守。审核人员经过严格培训和考核，确保审核标准的统一性和准确性。</p>
      
      <h3>第三层：专家终审</h3>
      <p>对于复杂、争议性内容，由资深内容安全专家组成的终审团队进行最终判定。终审团队同时负责审核规则的持续优化和案例库的更新维护。</p>
      
      <h2>用户举报机制</h2>
      <p>我们鼓励用户积极参与内容监督。在每条视频的播放页面都设有便捷的举报入口，用户可以对违规内容进行举报。所有举报将在2小时内得到处理，举报人将收到处理结果反馈。</p>
      
      <h2>未成年人保护</h2>
      <p>快猫严格执行国家关于未成年人网络保护的各项规定。我们设有青少年模式，开启后将限制使用时长、过滤不适内容、关闭打赏功能。同时，平台严禁未成年人进行直播和内容变现。</p>
      
      <h2>数据安全</h2>
      <p>快猫已通过国家信息安全等级保护三级认证，用户数据采用银行级加密存储，确保每一位用户的隐私安全。</p>
    `,
  },
  {
    id: 4,
    title: "从0到100万粉丝：快猫创作者成长全攻略",
    slug: "creator-growth-guide",
    excerpt: "系统梳理快猫平台上从新手到达人的成长路径，分享头部创作者的实战经验和运营心法。",
    cover: "https://readdy.ai/api/search-image?query=A%20creative%20workspace%20with%20a%20person%20filming%20content%20using%20a%20smartphone%20on%20a%20tripod%20with%20ring%20light%20in%20a%20bright%20modern%20room%2C%20content%20creator%20lifestyle%20photography&width=1200&height=675&seq=article-growth-04&orientation=landscape",
    category: "创作指南",
    author: "快猫创作者学院",
    date: "2026-03-25",
    readTime: "12分钟",
    views: "15.8万",
    tags: ["创作者", "涨粉攻略", "运营技巧"],
    content: `
      <p>在快猫平台上，每天都有无数的新创作者加入。如何从0开始，一步步成长为百万粉丝达人？本文为你系统梳理快猫创作者的完整成长路径。</p>
      
      <h2>第一阶段：新手期（0-1000粉丝）</h2>
      <p>目标：找准定位，积累第一批作品</p>
      <ul>
        <li><strong>确定赛道：</strong>选择一个你真正热爱且擅长的内容方向，搞笑段子、美食探店、知识科普、才艺展示等都是热门赛道。</li>
        <li><strong>研究对标：</strong>找到3-5位同赛道的成功创作者，分析他们的内容风格和选题策略，但不直接模仿。</li>
        <li><strong>保持更新：</strong>新手期建议每周至少发布3-5条视频，用数量积累经验和数据。</li>
        <li><strong>利用新创作者流量扶持：</strong>快猫对新创作者有专属的冷启动流量池，善用这一窗口期。</li>
      </ul>
      
      <h2>第二阶段：成长期（1000-10000粉丝）</h2>
      <p>目标：优化内容质量，建立个人风格</p>
      <ul>
        <li><strong>数据分析：</strong>通过快猫创作者后台查看每期视频的播放量、完播率、互动率等核心指标，找出高表现内容的共性。</li>
        <li><strong>黄金3秒：</strong>视频前3秒决定用户是否继续观看。用悬念、冲突、视觉冲击抓住用户注意力。</li>
        <li><strong>互动运营：</strong>积极回复评论，发起话题讨论，培养核心粉丝群体。</li>
      </ul>
      
      <h2>第三阶段：爆发期（10000-100000粉丝）</h2>
      <p>目标：打造爆款，建立品牌</p>
      <ul>
        <li><strong>追热点能力：</strong>学会结合热点事件和话题进行创作，善用快猫热榜和话题标签。</li>
        <li><strong>系列化内容：</strong>建立固定栏目或系列内容，培养用户的持续关注习惯。</li>
        <li><strong>跨平台联动：</strong>适当引导其他社交平台的粉丝关注快猫账号，实现流量聚合。</li>
      </ul>
      
      <h2>第四阶段：成熟期（100000+粉丝）</h2>
      <p>目标：商业变现，持续创新</p>
      <ul>
        <li><strong>多元变现：</strong>开通直播打赏、参与品牌任务市场、开设知识付费专栏、探索电商带货。</li>
        <li><strong>内容升级：</strong>提升制作水准，尝试更高质量的内容形式。</li>
        <li><strong>IP打造：</strong>围绕个人品牌进行多维度延伸。</li>
      </ul>
    `,
  },
  {
    id: 5,
    title: "快猫「星光计划」第三期启动：50亿扶持基金助力创作",
    slug: "starlight-plan-phase3",
    excerpt: "快猫正式启动星光计划第三期，总扶持基金规模达50亿元，覆盖流量、变现、工具三大维度，全面助力创作者成长。",
    cover: "https://readdy.ai/api/search-image?query=A%20dramatic%20stage%20with%20golden%20spotlights%20and%20sparkling%20stars%20on%20a%20dark%20elegant%20background%2C%20grand%20ceremony%20atmosphere%2C%20achievement%20and%20success%20concept&width=1200&height=675&seq=article-starlight-05&orientation=landscape",
    category: "平台动态",
    author: "快猫官方",
    date: "2026-02-18",
    readTime: "6分钟",
    views: "9.3万",
    tags: ["星光计划", "创作者扶持", "平台动态"],
    content: `
      <p>快猫短视频正式宣布启动「星光计划」第三期，总规模达50亿元的创作者扶持基金，将从流量、变现、工具三大维度全面助力创作者成长。</p>
      
      <h2>星光计划3.0核心内容</h2>
      
      <h3>流量扶持升级</h3>
      <p>第三期星光计划将流量扶持规模扩大至前两期的三倍。新创作者入驻即可获得专属流量包，优质内容将获得多轮推流机会。同时引入「内容质量分」机制，高质量内容将获得更多流量倾斜。</p>
      
      <h3>商业变现扩容</h3>
      <p>全新的品牌任务市场正式上线，品牌方可以直接发布创作任务，创作者接单创作获取收益。此外，直播带货分成比例提升至最高70%，知识付费专栏零门槛开通。</p>
      
      <h3>创作工具免费开放</h3>
      <p>快影AI创作工具向所有创作者免费开放，支持AI智能剪辑、自动字幕生成、智能封面推荐、一键成片等功能，大幅降低内容制作门槛。</p>
      
      <h2>申请条件</h2>
      <p>星光计划面向所有快猫创作者开放，只需满足以下基本条件：</p>
      <ul>
        <li>完成实名认证</li>
        <li>近30天内发布不少于5条原创视频</li>
        <li>账号无违规记录</li>
      </ul>
      
      <p>符合条件的创作者可在快猫App「创作者中心」-「星光计划」中提交申请。</p>
    `,
  },
  {
    id: 6,
    title: "快猫App V8.0版本发布：全新界面、智能推荐大升级",
    slug: "app-v8-release",
    excerpt: "快猫App迎来V8.0大版本更新，全新视觉设计语言、智能推荐算法重构、沉浸式播放体验全面优化。",
    cover: "https://readdy.ai/api/search-image?query=A%20modern%20smartphone%20displaying%20a%20colorful%20video%20app%20interface%20on%20a%20minimal%20desk%20with%20soft%20lighting%2C%20clean%20tech%20product%20photography%2C%20contemporary%20design&width=1200&height=675&seq=article-app-06&orientation=landscape",
    category: "产品更新",
    author: "快猫设计团队",
    date: "2026-01-08",
    readTime: "5分钟",
    views: "18.2万",
    tags: ["版本更新", "产品设计", "智能推荐"],
    content: `
      <p>快猫App V8.0版本正式上线！这是快猫App迄今为止最大规模的版本更新，从视觉设计到核心推荐算法都进行了全面重构。</p>
      
      <h2>全新视觉语言</h2>
      <p>V8.0采用了全新的「流动」设计语言，灵感来源于电影胶片与水波的交织。整体界面更加简洁通透，减少了视觉噪音，让内容本身成为主角。暗色模式也经过了重新设计，在夜间使用更加舒适。</p>
      
      <h2>智能推荐3.0</h2>
      <p>推荐算法进行了重大升级：</p>
      <ul>
        <li><strong>多模态理解：</strong>算法现在能同时理解视频画面、音频和文字内容，推荐更加精准。</li>
        <li><strong>实时兴趣捕捉：</strong>不再仅依赖历史行为，而是能实时感知用户当前的兴趣变化。</li>
        <li><strong>多样性保障：</strong>在精准推荐的同时，确保内容多样性，避免信息茧房。</li>
      </ul>
      
      <h2>沉浸式播放器</h2>
      <p>全新的沉浸式播放器支持上下滑动切换视频，配合流畅的动画过渡，带来丝滑的刷视频体验。同时新增了「纯净模式」，一键隐藏所有UI元素，全身心投入内容。</p>
      
      <h2>性能优化</h2>
      <p>V8.0版本App启动速度提升40%，视频首帧加载时间降低35%，流量消耗优化25%。</p>
      
      <p>快猫V8.0已在各大应用商店同步上架，快更新体验全新版本吧！</p>
    `,
  },
];

export const aboutData = {
  brand: {
    title: "关于快猫",
    subtitle: "让每个瞬间都有价值",
    description: "快猫短视频成立于2020年，是国内领先的短视频内容平台。我们致力于通过技术创新，让每个人都能轻松记录、创作和分享生活中的精彩瞬间。从最初的十几人小团队，发展到如今超过3000名员工的规模，快猫始终秉持「内容为王，用户至上」的理念，为数亿用户提供优质的短视频服务。",
    mission: "用科技让创作更简单，让分享更快乐",
    vision: "成为全球最受欢迎的短视频创作与分享平台",
    values: [
      { title: "用户至上", description: "一切以用户体验为核心，持续优化产品和服务" },
      { title: "内容为王", description: "坚持高品质内容导向，打造健康的内容生态" },
      { title: "技术驱动", description: "持续投入技术研发，用创新推动行业进步" },
      { title: "开放共赢", description: "与创作者、合作伙伴共同成长，共享发展成果" },
    ],
  },
  milestones: [
    { year: "2020年3月", event: "快猫短视频正式上线，首月用户突破100万" },
    { year: "2020年9月", event: "完成A轮融资，用户规模突破1000万" },
    { year: "2021年6月", event: "推出创作者扶持计划，创作者数量突破10万" },
    { year: "2022年1月", event: "日活跃用户突破5000万，进入短视频行业第一梯队" },
    { year: "2022年12月", event: "全年营收突破50亿元，实现规模化盈利" },
    { year: "2023年8月", event: "国际版正式上线，开启全球化布局" },
    { year: "2024年5月", event: "累计用户突破2亿，创作者数量超过300万" },
    { year: "2025年3月", event: "AI创作工具「快影」发布，引领AI+短视频新趋势" },
    { year: "2025年11月", event: "星光计划累计投入超100亿元，扶持创作者超50万人" },
    { year: "2026年6月", event: "累计用户突破3.2亿，稳居国内短视频平台前三" },
  ],
  contact: {
    title: "联系我们",
    subtitle: "我们期待听到你的声音",
    address: "浙江省杭州市余杭区未来科技城快猫大厦",
    phone: "0571-8888-6666",
    email: "contact@kuaimao.com",
    workingHours: "周一至周五 9:00-18:00",
    socialMedia: [
      { name: "微信公众号", icon: "ri-wechat-2-line" },
      { name: "新浪微博", icon: "ri-weibo-line" },
      { name: "知乎机构号", icon: "ri-question-answer-line" },
      { name: "B站官方号", icon: "ri-bilibili-line" },
    ],
  },
};